import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.ETICKET_SERVER_PREFIX}/sales`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    getSaleById: (id: any) => `${RESOURCE_ENDPOINT}/get-sale-all-info/${id}`,
    getCounterByEmployeeId: () => `${RESOURCE_ENDPOINT}/get-counter-info`,
    getByWhere: () => `${RESOURCE_ENDPOINT}/getByWhere`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    getSeatLayout: () => `${RESOURCE_ENDPOINT}/get-seat-layout`,
    getAutoSelectSeat: () => `${RESOURCE_ENDPOINT}/get-available-seat`,
    getAutoDeSelectSeat: () => `${RESOURCE_ENDPOINT}/delete-reserve-seat`,
    getAssignedProgramInfo: () => `${RESOURCE_ENDPOINT}/get-assign-program`,
}

export default class TicketSaleApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public getSaleById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getSaleById(id);
        return HttpService.get(url);
    }

    public getCounterByEmployeeId = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCounterByEmployeeId();
        return HttpService.get(url, params, headers);
    }

    public getByWhere = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getByWhere();
        return HttpService.get(url, params, headers);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

    public getSeatLayout = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getSeatLayout();
        return HttpService.get(url, params, headers);
    }

    public getAutoSelectSeat = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAutoSelectSeat();
        return HttpService.get(url, params, headers);
    }

    public getAutoDeSelectSeat = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAutoDeSelectSeat();
        return HttpService.get(url, params, headers);
    }

    public getAssignedProgramInfo = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAssignedProgramInfo();
        return HttpService.get(url, params, headers);
    }
}
